// extracted by mini-css-extract-plugin
export default {"addButtonContainer":"OrganizationsTable__addButtonContainer-kbgmG"};